"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _semanticUiReact = require("semantic-ui-react");

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDateRange = require("react-date-range");

var _moment = require("moment");

var _moment2 = _interopRequireDefault(_moment);

require("moment/locale/ca");

var _dateFns = require("date-fns");

var _locale = require("react-date-range/dist/locale");

var _constants = require("../../utils/constants");

var CONSTANTS = _interopRequireWildcard(_constants);

var _request = require("../../common/request");

var _request2 = _interopRequireDefault(_request);

var _PanelModificaRangTemporal = require("./PanelModificaRangTemporal.css");

var _PanelModificaRangTemporal2 = _interopRequireDefault(_PanelModificaRangTemporal);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PanelModificaRangTemporal = function (_Component) {
    _inherits(PanelModificaRangTemporal, _Component);

    function PanelModificaRangTemporal(props) {
        _classCallCheck(this, PanelModificaRangTemporal);

        var _this = _possibleConstructorReturn(this, (PanelModificaRangTemporal.__proto__ || Object.getPrototypeOf(PanelModificaRangTemporal)).call(this, props));

        _this.getInitEndDate = function (timemax, singledays, dynamic) {
            return singledays && dynamic ? new Date() : new Date(timemax);
        };

        _this.isDiaActual = function (timemax) {
            return (0, _moment2.default)(timemax).format("YYYY-MM-DD") === (0, _moment2.default)(new Date()).format("YYYY-MM-DD");
        };

        _this.isCheckedDiaActual = function (date) {
            return _this.state.singledays && _this.isDiaActual(date);
        };

        _this.isMoreThanThreeMonths = function (currentRange) {
            return (0, _dateFns.differenceInMonths)(currentRange.endDate, currentRange.startDate) >= 3;
        };

        _this.state = {
            showError: false,
            extraMsg: "",
            disabled: true,
            isLoading: false,
            singledays: false,
            myselection: {
                startDate: new Date(props.timerange.timemin),
                endDate: _this.getInitEndDate(props.timerange.timemax, props.timerange.singledays, props.timerange.dynamic),
                key: "myselection"
            }

        };

        return _this;
    }

    _createClass(PanelModificaRangTemporal, [{
        key: "componentDidMount",
        value: function componentDidMount() {}
    }, {
        key: "handleSelectRange",
        value: function handleSelectRange(range) {

            var currentRange = range.myselection;
            var checkedDiaActual = this.isCheckedDiaActual(currentRange.endDate);

            if (this.isMoreThanThreeMonths(currentRange) && !this.state.singledays) {

                currentRange.startDate = (0, _dateFns.subMonths)(currentRange.endDate, 3);
            }

            this.setState({ myselection: currentRange, disabled: false });
            //this.props.timerange.tipustipus:custom
            /*
            this.props.updateJsonConfig(
                ["timerange", "calcdatafieldsOptions", "calcdatafieldsCalculs"],
                [
                    {...this.props.timerange, timemax: format(currentRange.endDate, "yyyy-mm-dd"), timemin: format(currentRange.startDate, "yyyy-mm-dd"), dynamic: checkedDiaActual},
                    {...CONSTANTS.defaultJsonConfig.calcdatafieldsOptions, granularitat: (checkedDiaActual && this.props.timerange.singledays ? CONSTANTS.GRANULARITAT_HORES : CONSTANTS.GRANULARITAT_DIES)},
                    CONSTANTS.defaultJsonConfig.calcdatafieldsCalculs
                ]
            );
            */
        }
    }, {
        key: "changeRangeData",
        value: function changeRangeData() {

            this.setState({ isLoading: true });
            var myselection = this.state.myselection;

            this.props.dataJsonConfig.vieweroptions.layoutoptions.title = CONSTANTS.DEFAULT_TITOL_GENERIC;
            this.props.updateCalendarViewer("timerange", _extends({}, this.props.timerange, { timemax: (0, _moment2.default)(myselection.endDate).format("YYYY-MM-DD"), timemin: (0, _moment2.default)(myselection.startDate).format("YYYY-MM-DD"), dynamic: false, tipus: "custom", singledays: this.state.singledays }));
        }
    }, {
        key: "handleChangeToggleSingleDays",
        value: function handleChangeToggleSingleDays(checked) {

            this.setState({ singledays: checked });
        }
    }, {
        key: "renderSinglesDays",
        value: function renderSinglesDays(doRender) {
            var _this2 = this;

            /// const { timerange } = this.props;

            var myselection = this.state.myselection;


            return _react2.default.createElement(
                "div",
                { className: _PanelModificaRangTemporal2.default.singleDaysBox },
                _react2.default.createElement(
                    _semanticUiReact.Label,
                    { color: "teal" },
                    "Dia 1"
                ),
                " ",
                (0, _moment2.default)(myselection.startDate).format("DD/MM/YYYY"),
                _react2.default.createElement(
                    _semanticUiReact.Label,
                    { className: _PanelModificaRangTemporal2.default.dia2, color: "teal" },
                    "Dia 2"
                ),
                " ",
                (0, _moment2.default)(myselection.endDate).format("DD/MM/YYYY"),
                _react2.default.createElement(_semanticUiReact.Checkbox, { label: "2 dies concrets", checked: this.state.singledays, onChange: function onChange(e, data) {
                        return _this2.handleChangeToggleSingleDays(data.checked);
                    }, className: _PanelModificaRangTemporal2.default.chkdies })
            );
        }
    }, {
        key: "renderDateRange",
        value: function renderDateRange() {
            var _this3 = this;

            var _state = this.state,
                disabled = _state.disabled,
                isLoading = _state.isLoading;


            return _react2.default.createElement(
                "span",
                null,
                _react2.default.createElement(
                    _semanticUiReact.Message,
                    { compact: true, info: true },
                    _react2.default.createElement(
                        _semanticUiReact.Message.List,
                        null,
                        _react2.default.createElement(
                            _semanticUiReact.Message.Item,
                            null,
                            "Per seleccionar ",
                            _react2.default.createElement(
                                "b",
                                null,
                                "1 \xFAnic dia"
                            ),
                            " marca l'inici i el final del rang al mateix dia del calendari."
                        ),
                        _react2.default.createElement(
                            _semanticUiReact.Message.Item,
                            null,
                            "Per seleccionar ",
                            _react2.default.createElement(
                                "b",
                                null,
                                "2 dies"
                            ),
                            " selecciona'ls com si fos un rang i habilita la opci\xF3 ",
                            _react2.default.createElement(
                                "i",
                                null,
                                "Selecci\xF3 de 2 dies concrets"
                            ),
                            ". "
                        ),
                        _react2.default.createElement(
                            _semanticUiReact.Message.Item,
                            null,
                            "El m\xE0xim rang temporal perm\xE8s \xE9s de ",
                            _react2.default.createElement(
                                "b",
                                null,
                                "3 mesos."
                            )
                        ),
                        _react2.default.createElement(
                            _semanticUiReact.Message.Item,
                            null,
                            "Els visor ",
                            _react2.default.createElement(
                                "b",
                                null,
                                "NO"
                            ),
                            " ser\xE0 din\xE0mic"
                        ),
                        _react2.default.createElement(
                            _semanticUiReact.Message.Item,
                            null,
                            "Es generar\xE0 un ",
                            _react2.default.createElement(
                                "b",
                                null,
                                "NOU"
                            ),
                            "  visor."
                        )
                    )
                ),
                _react2.default.createElement(
                    "div",
                    { className: _PanelModificaRangTemporal2.default.containerCheckDinamic },
                    this.renderSinglesDays(this.props.timerange.singledays)
                ),
                _react2.default.createElement(_reactDateRange.DateRange, {
                    maxDate: (0, _dateFns.subDays)(new Date(), this.state.singledays ? 0 : 1),
                    color: "#00b5ad",
                    rangeColors: ["#00b5ad", "#00b5ad"],
                    className: _PanelModificaRangTemporal2.default.previewArea,
                    locale: _locale.ca,
                    direction: "horizontal",
                    months: 2,
                    ranges: [this.state.myselection],
                    onChange: function onChange(range) {
                        return _this3.handleSelectRange(range);
                    },
                    moveRangeOnFirstSelection: false,
                    showSelectionPreview: true
                }),
                _react2.default.createElement(
                    "div",
                    { className: _PanelModificaRangTemporal2.default.btaccions },
                    _react2.default.createElement(
                        _semanticUiReact.Button,
                        { disabled: disabled, loading: isLoading, onClick: function onClick(e, data) {
                                return _this3.changeRangeData(data);
                            }, color: "teal" },
                        "Aplicar canvi"
                    ),
                    _react2.default.createElement(
                        _semanticUiReact.Button,
                        { onClick: function onClick(e, data) {
                                return _this3.props.onClosePanel(data);
                            }, negative: true },
                        "Tancar"
                    )
                )
            );
        }
    }, {
        key: "render",
        value: function render() {

            return _react2.default.createElement(
                "div",
                { className: _PanelModificaRangTemporal2.default.containerDinamic },
                _react2.default.createElement(
                    "div",
                    { className: _PanelModificaRangTemporal2.default.containerDaterange },
                    this.renderDateRange()
                )
            );
        }
    }]);

    return PanelModificaRangTemporal;
}(_react.Component);

exports.default = PanelModificaRangTemporal;


PanelModificaRangTemporal.propTypes = {
    dataJsonConfig: _propTypes2.default.object,
    timerange: _propTypes2.default.object,
    onClosePanel: _propTypes2.default.func,
    data: _propTypes2.default.object,
    updateCalendarViewer: _propTypes2.default.func
};
